import { Validator } from '../classes/Validator';

document.addEventListener('DOMContentLoaded', () => {
	const forms = document.querySelectorAll<HTMLFormElement>('.form');
	if (!forms || forms.length === 0) {
		return;
	}

	forms.forEach((form) => {
		new Validator(form, {
			fieldSelector: '.js-validate',
			onFieldValidated(field, valid) {
				if ((field as HTMLInputElement).type === 'checkbox') {
					return;
				}

				const hasValue = (field.value ?? '').trim().length > 0;

				field.classList.toggle('is-valid', valid && hasValue);
			},
		});
	});
});
